import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AlphaHttpClient } from './alpha-http-client';
export interface Tenant {
    description: string;
    name: string;
    status: string;
}
@Injectable({ providedIn: 'root' })
export class TenantService {
    private domainUrl = {
        type: 'environment',
        value: {
            __alpha_env__: 'ALPHA_UI_CONFIG_SERVICE_URL',
        },
    };
    private tenant: string | null = null;
    private httpClient: AlphaHttpClient = inject(AlphaHttpClient);

    async saveTenant(tenant: string) {
        const response = await lastValueFrom(
            this.httpClient.post<Tenant>(this.domainUrl, '/tenant/create', { name: tenant }),
        ).catch((error) => {
            console.error(error);
            throw new Error('Error while saving tenant');
        });
        this.tenant = response.name;
        return response;
    }

    fetchTenant() {
        return this.tenant;
    }
}
